export const SET_CHAT_BOT_MESSAGE_VALUE = "SET_CHAT_BOT_MESSAGE_VALUE";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const ADD_BOT_MESSAGE = "ADD_BOT_MESSAGE";
export const SET_INPUT_DISABLE = "SET_INPUT_DISABLE";
export const LOADING_BOT_MESSAGE = "LOADING_BOT_MESSAGE";
export const DISABLE_DATE_PICKER = "DISABLE_DATE_PICKER";
export const SET_USER_INFOS = "SET_USER_INFOS";
export const SET_SELECTED_TIME = "SET_SELECTED_TIME";
export const SET_SELECTED_DAY = "SET_SELECTED_DAY";
export const SEND_PLAN_DEMAND = "SEND_PLAN_DEMAND";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_FIRSTNAME = "UPDATE_FIRSTNAME";
export const UPDATE_LASTNAME = "UPDATE_LASTNAME";
export const UPDATE_ADRESS = "UPDATE_ADRESS";
export const UPDATE_CITY = "UPDATE_CITY";
export const UPDATE_ZIP_CODE = "UPDATE_ZIP_CODE";
export const UPDATE_PHONE_NUMBER = "UPDATE_PHONE_NUMBER";
export const CLEAR_CHAT_BOT = "CLEAR_CHAT_BOT";

export const setChatBotMessageValue = (value) => ({
	type: SET_CHAT_BOT_MESSAGE_VALUE,
	value
});

export const addMessage = (message, messageType) => ({
	type: ADD_MESSAGE,
	message,
	messageType
});

export const addBotMessage = (message, messageType) => ({
	type : ADD_BOT_MESSAGE,
	message,
	messageType
});

export const setInputDisable = (bool) => ({
	type : SET_INPUT_DISABLE,
	bool
});

export const loadingBotMessage = (bool) => ({
	type: LOADING_BOT_MESSAGE,
	bool
});

export const disableDatePicker = (bool) => ({
	type : DISABLE_DATE_PICKER,
	bool
});

export const setUserInfos = (value, infoType) => ({
	type: SET_USER_INFOS,
	value,
	infoType
});

export const setSelectedDay = (day) => ({
	type: SET_SELECTED_DAY,
	day
});

export const setSelectedTime = (time) => ({
	type: SET_SELECTED_TIME,
	time
});

export const sendPlanDemand = () => ({
	type: SEND_PLAN_DEMAND
});

export const updateUser = (value) => ({
	type : UPDATE_USER,
	value
});

export const updateFirstname = () => ({
	type : UPDATE_FIRSTNAME,
});

export const updatePhoneNumber = () => ({
	type : UPDATE_PHONE_NUMBER,
});

export const updateLastname = () => ({
	type : UPDATE_LASTNAME,
});

export const updateAdress = () => ({
	type : UPDATE_ADRESS,
});

export const updateCity = () => ({
	type : UPDATE_CITY,
});

export const updateZIPCode = () => ({
	type : UPDATE_ZIP_CODE,
});

export const clearChatBot = () => ({
	type: CLEAR_CHAT_BOT
});

